<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAdjust_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M5 4a1 1 0 0 0-1 1v5H3a1 1 0 1 0 0 2h1v7a1 1 0 1 0 2 0v-7h1a1 1 0 1 0 0-2H6V5a1 1 0 0 0-1-1m7 0a1 1 0 0 0-1 1v10h-1a1 1 0 1 0 0 2h1v2a1 1 0 1 0 2 0v-2h1a1 1 0 1 0 0-2h-1V5a1 1 0 0 0-1-1m6 1a1 1 0 1 1 2 0v2h1a1 1 0 1 1 0 2h-1v10a1 1 0 1 1-2 0V9h-1a1 1 0 1 1 0-2h1z"
        clip-rule="evenodd"
    />
</svg>
